import axios from "axios";
import HttpService from "../http";

const Subscription = () => {
  const { httpRequest, httpDecryptRequest, httpFormRequest } = HttpService();

  const plainListApi = (search) =>
    new Promise((resolve, reject) => {
      httpRequest("GET", "user/v1/subscription/list", {}, search)
        .then(resolve)
        .catch(reject);
    });
    

  const BuyThisPlanApi = (data) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/subscription/create_stripe_checkout", data)
        .then(resolve)
        .catch(reject);
    });

  const BuyRazorPaySubscriptionApi = (data) =>
    new Promise((resolve, reject) => {
      httpRequest("POST", "user/v1/subscription/create_rayzorpay_subscription", data)
        .then(resolve)
        .catch(reject);
    });

  // const getDoctorDetail = (search) =>
  //   new Promise((resolve, reject) => {
  //     httpRequest("GET", "user/v1/doctor/detail", {}, search)
  //       .then(resolve)
  //       .catch(reject);
  //   });
  //  const addUser = (payload) =>
  //     new Promise((resolve, reject) => {
  //       httpFormRequest("POST", "user/v1/auth/register", payload)
  //         .then(resolve)
  //         .catch(reject);
  //     });
  return { plainListApi,BuyThisPlanApi, BuyRazorPaySubscriptionApi };
};

export { Subscription };
